import { useEffect, useState } from 'react'
import firebase from '../firebase/compat'

/**
 * Haalt de definitie van een openbaar formulier op via een openbare Cloud
 * Function (getPublicQuestionnaire, getPublicEventForm). Die pagina's lezen de
 * definitiecollecties niet meer zelf: anoniem mag dat niet meer (2026-11-04).
 *
 * `data` is null zolang het antwoord onderweg is. Mislukt het, dan is `data`
 * `empty` (alsof het formulier niet bestaat) en staat de fout in `error`, zodat
 * de pagina 'niet gevonden' toont in plaats van eindeloos te laden.
 *
 * @template T
 * @param {string} callableName - Naam van de callable in europe-west1
 * @param {Object<string, string>|null} payload - null = nog niets op te vragen
 * @param {T} empty - De lege vorm, ook de basis waar het antwoord overheen gaat
 * @returns {{data: T|null, error: {code?: string, message?: string}|null}}
 */
const usePublicDefinition = (callableName, payload, empty) => {
    const [state, setState] = useState({ data: null, error: null })
    const key = payload ? JSON.stringify(payload) : ''

    useEffect(() => {
        setState({ data: null, error: null })
        if (!key) return undefined

        let active = true
        firebase.app().functions('europe-west1')
            .httpsCallable(callableName)(JSON.parse(key))
            .then((result) => {
                if (active) setState({ data: { ...empty, ...(result?.data || {}) }, error: null })
            })
            .catch((err) => {
                if (!active) return
                // eslint-disable-next-line no-console
                console.error(`[${callableName}] ophalen mislukt`, err)
                setState({ data: empty, error: { code: err?.code, message: err?.message } })
            })

        return () => { active = false }
        // `empty` is per aanroeper een vaste waarde op moduleniveau.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callableName, key])

    return state
}

export default usePublicDefinition
